import { render } from "./IntersectionEditorCmp.vue?vue&type=template&id=4fc5f162&scoped=true"
import script from "./IntersectionEditorCmp.vue?vue&type=script&lang=js"
export * from "./IntersectionEditorCmp.vue?vue&type=script&lang=js"

import "./IntersectionEditorCmp.vue?vue&type=style&index=0&id=4fc5f162&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fc5f162"]])

export default __exports__